import { Injectable } from '@angular/core';
import { BackendService } from 'auth/src/public-api';
import { UserSummaryData } from '../modals/ai-general-summary-modal/models/userSummaryData';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserPreview } from '../interfaces/user-preview.interface';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared/services/auth.service';

@Injectable()
export class AiSummaryService {

    constructor(
        private _httpService: BackendService,
        private authService: AuthService,
        private http: HttpClient
    ) {
    }

    public getReviewsAiUserSummary(cycleParticipantId: number) {
        return this._httpService.get<UserSummaryData>('getReviewsAiUserSummary', [], [
            { 'name': 'cycleParticipantId', 'value': cycleParticipantId as any },

        ]);
    }
}